import { CourseAuthor } from "@jelly/lesson";
import appConfig from "appConfig";

const author: CourseAuthor = {
  name: "André Kruh-Elendt",
  title: "Research Engineer at HEAD acoustics",
  description: `André Kruh-Elendt obtained his B.Sc. and M.Sc. degrees in Media Technology from the Department of Electrical Engineering at Ilmenau University of Technology. During his studies he worked as a student assistant at the Institute of Media Technology performing listening experiments and related DSP tasks. In 2016 he finished his master's thesis, targeting the efficient binaural rendering of ambisonics audio, at Technicolor R&I in Hannover. In 2017 he joined the 'Sound Perception & Assessment' group at HEAD acoustics as a research engineer and PhD candidate, focusing on the enhancement of binaural reproduction systems and the application of spatial audio technologies for sound evaluation.



  <ul>
    <li><a href="https://www.head-acoustics.com/" target="_blank">https://www.head-acoustics.com/</a></li>
    </ul>
  `,
  imageUrl: appConfig.ASSETS_URL + "/02/authors/andre-kruh-elendt.jpg",
};

export default author;
